module.exports = __webpack_public_path__ + "img/news3-4.461b6a68.jpeg";